import { SearchParameters } from '../../constants'
import { useFeatureFlags } from '../useFeatureFlags'
import { useSearchParameters } from '../useSearchParameters'

/**
 * Determines whether availability cache should be used for API requests.
 *
 * - ENABLE_AVAILABILITY_CACHE Flag on + non-preview: use cache
 * - Preview: do not use cache (flag is overridden)
 * - Preview + flag on + use_cache=true in URL: use cache (explicit override)
 */
const useAvailabilityCacheEnabled = (): boolean => {
  const [isAvailabilityCacheEnabled] = useFeatureFlags(['ENABLE_AVAILABILITY_CACHE'])
  const { [SearchParameters.PREVIEW]: previewParam, [SearchParameters.USE_CACHE]: useCacheParam } = useSearchParameters()

  const isPreview =
    String(previewParam ?? '')
      .trim()
      .toLowerCase() === 'true'
  const useCacheExplicit =
    String(useCacheParam ?? '')
      .trim()
      .toLowerCase() === 'true'

  if (isPreview) {
    return Boolean(isAvailabilityCacheEnabled && useCacheExplicit)
  }

  return Boolean(isAvailabilityCacheEnabled)
}

export { useAvailabilityCacheEnabled }
